import { render, staticRenderFns } from "./ParticipantBlock.vue?vue&type=template&id=5b89ed33&scoped=true&"
import script from "./ParticipantBlock.vue?vue&type=script&lang=js&"
export * from "./ParticipantBlock.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantBlock.vue?vue&type=style&index=0&id=5b89ed33&scoped=true&lang=css&"
import style1 from "./ParticipantBlock.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89ed33",
  null
  
)

export default component.exports